// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableDebug: true,

  numero_WhatsApp: "+393382202740",
  numero_telefono: "tel:+393382202740",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',
  */

  urlWeb: 'https://discentya.gesforacademy.online/',
  urlMaterialeDidattico: 'https://discentya.gesforacademy.online/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.gesforacademy.online/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.gesforacademy.online/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.gesforacademy.online/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.gesforacademy.online/api/',

  urlStampa: 'https://discentya.gesforacademy.online/stampe/',

  urlAttestati: 'https://discentya.gesforacademy.online/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.gesforacademy.online/pages/certificate/',
  urlImagePartners: 'https://discentya.gesforacademy.online/assets/media/partners/',
  urlImageMedia: 'http://discentya.gesforacademy.online/assets/media/',

};

